import type { BabyNameRequest, BabyNameEntry, BabyNameResponse } from "@ishvaram/api-client";
import { apiRequest } from "./_fetch";

export type { BabyNameRequest, BabyNameEntry, BabyNameResponse };

export async function suggestBabyNames(data: BabyNameRequest): Promise<BabyNameResponse> {
  return apiRequest<BabyNameResponse>("/baby-names", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(data),
  });
}
